import { Check, ChevronDown, ChevronUp } from 'lucide-react';

export enum SortingType {
  name = 'Name',
  date = 'Date',
  alphabetical = 'Alphabetical',
  recent = 'Recent',
}

export enum SortDirection {
  asc,
  desc,
}

const SortingMenu = ({
  handleSortChange,
  sortingItems,
  sortConfig,
}: {
  sortConfig: { key: SortingType; direction?: SortDirection };
  sortingItems: SortingType[];
  handleSortChange?: (sortingValue: SortingType) => void;
}) => {
  const getSortName = (type: SortingType) => {
    switch (type) {
      case SortingType.name:
        return 'Asset Name';
      case SortingType.alphabetical:
        return 'Alphabetical';
      case SortingType.date:
        return 'Date';
      case SortingType.recent:
        return 'Recent';
    }
  };

  const buildSortDirection = () => {
    if (sortConfig.direction === undefined) return null;
    return sortConfig.direction === SortDirection.asc ? (
      <ChevronUp className="size-4" />
    ) : (
      <ChevronDown className="size-4" />
    );
  };

  const buildSortConfig = () => {
    if (sortConfig.direction === undefined) return null;
    if (sortConfig.key === SortingType.date) {
      return sortConfig.direction === SortDirection.asc
        ? '(Old to New)'
        : '(New to Old)';
    } else if (sortConfig.key === SortingType.name) {
      return sortConfig.direction === SortDirection.asc
        ? '(A to Z)'
        : '(Z to A)';
    }
  };

  return (
    <div className="absolute top-12 right-0 z-10 rounded-lg border border-line bg-white shadow-lg">
      <div className="p-2">
        {sortingItems.map((s) => (
          <button
            key={s}
            className="flex w-full items-center justify-between rounded-sm p-2 text-left hover:bg-brandLight/30"
            onClick={() => handleSortChange?.(s)}
          >
            <span>
              <div className="flex">
                {getSortName(s)}
                {sortConfig.key === s ? (
                  <Check className="ml-2 text-black" />
                ) : null}
              </div>
              {buildSortConfig()}
            </span>
            {buildSortDirection()}
          </button>
        ))}
      </div>
    </div>
  );
};

export default SortingMenu;
